import { AnalyticsBrowser } from '@segment/analytics-next';
import React from 'react';
/**
 * Assumes a single Segment account will be in use. If there are multiple
 * Segment accounts, the queue needs to be
 * { [segmentKey: string]: Array<EventParams | null> }
 */
var eventQueue = [];
var pageQueue = [];
export var noOpAnalyticsBrowserObject = {
    track: function () {
        var eventParams = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            eventParams[_i] = arguments[_i];
        }
        eventQueue.push(eventParams);
    },
    page: function () {
        var pageParams = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            pageParams[_i] = arguments[_i];
        }
        pageQueue.push(pageParams);
    },
};
var SegmentContext = React.createContext(undefined);
export var SegmentProvider = function (_a) {
    var children = _a.children, writeKey = _a.writeKey, cdnURL = _a.cdnURL, enabled = _a.enabled;
    var analytics = React.useMemo(function () {
        if (enabled) {
            var segmentClient = AnalyticsBrowser.load({ writeKey: writeKey, cdnURL: cdnURL }, { disableClientPersistence: false, obfuscate: true });
            if (eventQueue.length > 0 || pageQueue.length > 0) {
                while (eventQueue.length > 0) {
                    var event_1 = eventQueue.shift();
                    if (event_1) {
                        segmentClient.track.apply(segmentClient, event_1);
                    }
                }
                while (pageQueue.length > 0) {
                    var event_2 = pageQueue.shift();
                    if (event_2) {
                        segmentClient.page.apply(segmentClient, event_2);
                    }
                }
            }
            return segmentClient;
        }
        return noOpAnalyticsBrowserObject;
    }, [writeKey, cdnURL, enabled]);
    return (React.createElement(SegmentContext.Provider, { value: analytics }, children));
};
export function useSegmentClient() {
    var context = React.useContext(SegmentContext);
    if (context === undefined) {
        throw new Error('Context used outside of its Provider!');
    }
    return context;
}
